import type { AppDispatch, RootState } from '../../../redux/store'
import type { ReactionBody } from '../model/types'

import { actions } from '../model/slice'
import { selectors } from './selectors'

function updateReactions(
	{ emoji, mark, message }: Omit<ReactionBody, 'conversation'>,
	{ dispatch, state }: { dispatch: AppDispatch; state: RootState }
) {
	const { reaction_summaries: olds } = selectors.messages.selectById(
		state,
		message
	)

	const found = olds.findIndex(reaction => reaction.emoji === emoji)

	const patch = [...olds]

	const shouldAddNewOne = mark && found === -1

	if (shouldAddNewOne) {
		patch.push({
			count: 1,
			emoji,
			viewerReacted: true
		})
	} else {
		const exist = found !== -1
		if (exist) {
			const newOne = { ...olds[found] }
			const shouldRemove = !mark && newOne.count < 2

			if (shouldRemove) {
				patch.splice(found, 1)
			} else {
				newOne.count += mark ? 1 : -1
				newOne.viewerReacted = mark

				patch[found] = newOne
			}
		}
	}

	dispatch(
		actions.updateMessage({
			changes: { reaction_summaries: patch },
			id: message
		})
	)

	return () =>
		dispatch(
			actions.updateMessage({
				changes: { reaction_summaries: olds },
				id: message
			})
		)
}

export { updateReactions }
